import React from "react";
import "./ImagesOfProjects.css";

const ImagesOfProjects = () => {
  return (
    <div>
      <h2>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Velit, veniam.
      </h2>
    </div>
  );
};

export default ImagesOfProjects;
